<script setup>
import { Inertia } from '@inertiajs/inertia';

defineProps({
	comment: Object,
})

const deleteComment = (id) => {
	Inertia.delete(route('member.post.destroy_comment', { comment: id }), {
		preserveState: true,
		preserveScroll: true
	})
}
</script>

<template>
	<div v-if="comment.commentator" class="d-flex mb-4">
        <img
			class="img-avatar img-avatar48 flex-shrink-0 me-3"
			:src="
				comment.commentator.avatar === 'default-avatar.png'
					? 'https://ui-avatars.com/api/?size=128&background=fad859&color=fff&font-size=0.5&bold=true&length=1&name=' +
					  comment.commentator.full_name
					: '/avatar/' + comment.commentator.avatar
			"
			alt="avatar"
		/>
		<div class="flex-grow-1">
			<p class="fs-sm fw-medium mb-1">
				<a class="fw-bold text-dark" href="javascript:void(0)">
                    {{ comment.commentator.full_name }}
					<span v-if="comment.canDelete">
						<span role="presentation" aria-hidden="true"> · </span>
						<a @click="deleteComment(comment.id)" class="link-fx text-danger fw-normal" href="javascript:void(0)">Delete</a>
					</span>
                </a>
				<p v-html="comment.content" class="text-muted"></p>
			</p>
			<div class="fs-sm fw-medium text-dark">
				<!-- <span class="badge bg-info me-1">
					<i class="fa fa-thumbs-up opacity-50 me-1"></i> 10
				</span> -->
				<a class="link-fx text-dark" href="javascript:void(0)"> Like </a>
				<span role="presentation" aria-hidden="true"> · </span>
				<a class="link-fx text-dark" href="javascript:void(0)"> Reply </a>
				<span role="presentation" aria-hidden="true"> · </span>
				<span class="text-muted me-1">{{ comment.commented_at }}</span>
			</div>
		</div>
	</div>
</template>
